module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "article-nav"
  }, [(_vm.prevPost) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'post',
        params: {
          id: _vm.prevPost.uid
        }
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 32 32"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 16c0 0.3 0.1 0.5 0.3 0.7l9.9 10c0.4 0.4 1 0.4 1.4 0 0.4-0.4 0.4-1 0-1.4L3.4 17H31c0.6 0 1-0.5 1-1s-0.4-1-1-1H3.4l8.2-8.3c0.4-0.4 0.4-1 0-1.4 -0.4-0.4-1-0.4-1.4 0l-9.9 10C0.1 15.5 0 15.7 0 16z",
      "fill": "#121313"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "c-home-button",
    attrs: {
      "to": {
        name: 'homepage'
      }
    }
  }, [_c('svg', {
    staticClass: "home",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "14",
      "viewBox": "0 0 100 100"
    }
  }, [_c('path', {
    attrs: {
      "d": "M50,4.9L5.1,47L5,47.1v9.7l11.1-10.6v48.6h67.8V46.3L95,56.9v-9.7L50,4.9z M50,14.3l27.6,26v48.3h-55V40L50,14.3z"
    }
  })])]), _vm._v(" "), (_vm.nextPost) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'post',
        params: {
          id: _vm.nextPost.uid
        }
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "32",
      "viewBox": "0 0 32 32",
      "width": "32"
    }
  }, [_c('path', {
    attrs: {
      "d": "M32 16c0-0.3-0.1-0.5-0.3-0.7l-9.9-10c-0.4-0.4-1-0.4-1.4 0 -0.4 0.4-0.4 1 0 1.4l8.2 8.3H1c-0.6 0-1 0.5-1 1s0.4 1 1 1h27.6l-8.2 8.3c-0.4 0.4-0.4 1 0 1.4 0.4 0.4 1 0.4 1.4 0l9.9-10C31.9 16.5 32 16.3 32 16z",
      "fill": "#121313"
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f9f7ccc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleNav.vue
// module id = 84
// module chunks = 0